import { useContext } from 'react';
import { createStore } from 'zustand/vanilla';

import { CommonStoreContext } from './provider';
import { useAuthSlice } from './slices/auth/useAuthSlice';
import { useAddonsSlice } from './slices/useAddonsSlice';
import { useBonanzaPromoSlice } from './slices/useBonanzaPromoSlice';
import { useDiceRollSlice } from './slices/useDiceRollSlice';
import { useFortuneWheelSlice } from './slices/useFortuneWheelSlice';
import { useGameSlice } from './slices/useGameSlice';
import { useHeadlinePromoSlice } from './slices/useHeadlinePromoSlice';
import { useLoyaltySseSlice } from './slices/useLoyaltySseSlice';
import { usePlayerSlice } from './slices/usePlayerSlice';
import { useRealTimeServiceSlice } from './slices/useRealTimeServiceSlice';
import { useScratchGameSlice } from './slices/useScratchGameSlice';
import { useTechInfoSlice } from './slices/useTechInfoSlice';
import { useTournamentsSlice } from './slices/useTournamentsSlice';
import type { CommonStoreType } from './types';

export const createCommonStore = (preloadedState?: Partial<CommonStoreType>) =>
  createStore<CommonStoreType>((...a) => ({
    ...useTechInfoSlice(...a),
    ...usePlayerSlice(...a),
    ...useAuthSlice(...a),
    ...useAddonsSlice(...a),
    ...useGameSlice(...a),
    ...useRealTimeServiceSlice(...a),
    ...useTournamentsSlice(...a),
    ...useHeadlinePromoSlice(...a),
    ...useBonanzaPromoSlice(...a),
    ...useScratchGameSlice(...a),
    ...useFortuneWheelSlice(...a),
    ...useDiceRollSlice(...a),
    ...useLoyaltySseSlice(...a),
    ...preloadedState,
  }));

export const useGetCommonStore = () => {
  const commonStoreContext = useContext(CommonStoreContext);

  if (!commonStoreContext) {
    throw new Error(
      'useBoundCommonStore must be used within CommonStoreProvider'
    );
  }

  return commonStoreContext.selectors;
};
